import { Box, Flex, Text } from '@chakra-ui/react';
import { DAY_ABBREVIATION, MONTH_ABBREVIATION } from 'utils';

type Dates = {
  start: Date;
  end: Date;
};

type DatesTileProps = {
  dates: Dates;
};

const DatesTile = ({ dates }: DatesTileProps) => {
  return (
    <Box
      width='100%'
      padding={[3, 5]}
      boxShadow='3px 20px 25px -5px rgba(151, 151, 151, 0.1), 3px 10px 10px -5px rgba(151, 151, 151, 0.04)'
      borderRadius={[10, 20, 30]}
    >
      <Flex justifyContent='space-between'
      >
        <Text fontFamily='Montserrat' fontSize='16px' fontWeight={500} color='#A3A3A3'>Departure</Text>
        <Text fontFamily='Montserrat' fontSize='16px' fontWeight={500} color='#A3A3A3'>Return</Text>
      </Flex>

      <Flex justifyContent='space-between'
        gap={4}
      >
        <Flex gap={[2, 4]} direction={['column', 'row']} alignItems={['flex-']}>
          <Text fontFamily='Montserrat'
            fontSize={['16,20,24,36']}
            fontWeight={700} color='#000000'>
            {`${dates.start.getDate()} ${MONTH_ABBREVIATION[dates.start.getMonth()]}, ${DAY_ABBREVIATION[dates.start.getDay()]}`}
          </Text>
            <Text fontFamily='Montserrat' fontSize='17px' fontWeight={400} color='#6F6F6F'>
            {dates.start.getHours() + ':' + dates.start.getMinutes()}
            </Text>
        </Flex>

        <Flex gap={[2, 4]} direction={['column', 'row']} alignItems={['flex-end']}>
          <Text fontFamily='Montserrat'
            fontSize={['16,20,24,36']}
            fontWeight={700} color='#000000'>
            {`${dates.end.getDate()} ${MONTH_ABBREVIATION[dates.end.getMonth()]}, ${DAY_ABBREVIATION[dates.end.getDay()]}`}
          </Text >
            <Text fontFamily='Montserrat' fontSize='17px' fontWeight={400} color='#6F6F6F'>
            {dates.end.getHours() + ':' + dates.end.getMinutes()}
            </Text>
        </Flex >
      </Flex >

    </Box>
  );
};

export { DatesTile };
